import { Box, Chip, Divider, Typography } from "@mui/material";
import useColors from "../../../../../../../../api/hooks/useColors";
import iconMapping from "../../../../../../../../icons/IconMapping";
import SvgToIcon from "../../../../../../../../icons/SvgToIcon";
import { RemediationType } from "../../../../../../../../utils/constants";
import ChipColor from "../../../../../../../remediation/plan/components/ChipColor";
import { ReactComponent as CloseIcon } from "../../../../../../../stack/environment/icons/close_icon.svg";
import { IntegrationsMapping } from "../../../../../../../stack/integrations/IntegrationsMapping";

export default function WizardHeader({
  step_number,
  title,
  control,
  remediation,
  handleClose,
  loadingConfirmation,
}) {
  const colors = useColors();
  const EntitiesIcon = iconMapping["Inventory"];
  const numberOfEntities = control?.impacted_included_entities_count || 0;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2" color={colors.text_secondary}>
            Step {step_number} of 2
          </Typography>
          <Box
            height="18px"
            onClick={!loadingConfirmation ? handleClose : () => {}}
            sx={{
              cursor: !loadingConfirmation ? "pointer" : "auto",
            }}
          >
            <SvgToIcon
              IconLogo={CloseIcon}
              width="18px"
              style={{ color: colors.action_active }}
            />
          </Box>
        </Box>
        <Typography variant="subtitle1" color={colors.text_primary}>
          {title}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        gap={1}
        padding="8px"
        border={"1px solid " + colors.divider}
        borderRadius="10px"
        sx={{
          backgroundColor: colors.common_white,
        }}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          gap={0.5}
          padding="8px"
        >
          <Typography variant="subtitle2" color={colors.primary_main}>
            Remediation Info
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={3}
            paddingY="8px"
          >
            <Box
              display="flex"
              flexDirection="column"
              gap="14px"
              flexShrink={1}
              minWidth={0}
            >
              <Typography variant="body2" color={colors.text_secondary}>
                Remediation name
              </Typography>
              <Typography
                variant="body2"
                color={colors.text_primary}
                sx={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                Deny password revealing feature from privileged users
              </Typography>
            </Box>
            <Divider orientation="vertical" />
            <Box
              display="flex"
              flexDirection="column"
              gap="12px"
              paddingX="8px"
              alignItems="center"
              position="relative"
              flexShrink={0}
            >
              <Typography variant="body2" color={colors.text_secondary}>
                Tool
              </Typography>
              <Box position="absolute" top="27px">
                <SvgToIcon
                  IconLogo={IntegrationsMapping[control.tool].logo}
                  width={"35px"}
                />
              </Box>
            </Box>
            <Divider orientation="vertical" />
            <Box
              display="flex"
              flexDirection="column"
              gap="12px"
              flexShrink={0}
            >
              <Typography variant="body2" color={colors.text_secondary}>
                Priority
              </Typography>
              <ChipColor
                value={remediation.priority}
                type={RemediationType.REMEDIATION_PRIORITY}
                sx={{ width: "min-content" }}
              />
            </Box>
            <Divider orientation="vertical" />
            <Box
              display="flex"
              flexDirection="column"
              gap="12px"
              flexShrink={0}
            >
              <Typography variant="body2" color={colors.text_secondary}>
                Impact
              </Typography>
              <Chip
                label={numberOfEntities + " Entities"}
                icon={
                  <EntitiesIcon
                    style={{ color: colors.text_primary, width: "20px" }}
                  />
                }
                style={{
                  background: colors.entity_chip_enabled_fill,
                  borderRadius: "8px",
                  fontSize: "12px",
                  color: colors.text_primary,
                  boxShadow: colors.entity_chip_inventory_shadow,
                  height: "24px",
                  paddingLeft: "4px",
                  cursor: "default",
                  userSelect: "none",
                }}
              />
            </Box>
            <Divider orientation="vertical" />
            <Box
              display="flex"
              flexDirection="column"
              gap="12px"
              paddingRight="8px"
              flexShrink={0}
            >
              <Typography variant="body2" color={colors.text_secondary}>
                Gap ID
              </Typography>
              <Typography variant="body2" color={colors.text_primary}>
                #{control.control_id}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
